import type { ICase  } from "~~/types/case";
import { EStatus  } from "~~/types/case";
import {
  IconCheck,
  IconInfoCircle,
  IconAlertCircleFilled,
  IconHourglass,
  IconUserPause,
  IconX,
} from "@tabler/icons-vue";
import { formatServiceLabels } from "~/utils/service";
import { capitalize } from "vue";
import { Timestamp } from "firebase/firestore";

export const getCaseStatusIconColor = (status?: ICase["status"]) => {
  switch (status) {
    case EStatus.CREATED:
      return { icon: IconAlertCircleFilled, color: "bg-orange-400", text: "text-orange-400" };
    case EStatus.ONGOING:
      return { icon: IconHourglass, color: "bg-yellow-400", text: "text-yellow-400" };
    case EStatus.REASSIGNED:
    case EStatus.ASSIGNED:
      return { icon: IconUserPause, color: "bg-blue-400", text: "text-blue-400" };
    case EStatus.CLOSED:
      return { icon: IconX, color: "bg-red-400", text: "text-red-400" };
    case EStatus.ACCEPTED:
      return { icon: IconCheck, color: "bg-green-400", text: "text-green-400" };
    case EStatus.FINISHED:
      return { icon: IconCheck, color: "bg-green-700", text: "text-green-700" };
    default:
      return { icon: IconInfoCircle, color: "bg-gray-400", text: "text-gray-400" };
  }
};

export const getServiceText = (
  service?: ICase["choosedService"],
  providerServices?: Array<{ id: string; label: string; value: string; isActive: boolean }>,
  joinText = ", "
) => {
  if (!service || service.length === 0 || !providerServices) return "";

  return formatServiceLabels(service, providerServices, joinText);
};

export const getStateText = (state: ICase["location"]["state"], joinText = ", ") => {
  return state ? state.map((_state) => capitalize(_state.replace(/[-_\.]+/g, " "))).join(joinText) : "";
};

export const getDateTimeText = (date: Date | Timestamp) => {
  if (!date) {
    return "";
  }

  if (date instanceof Timestamp) {
    return date.toDate().toLocaleString();
  } else if (date instanceof Date) {
    return date.toLocaleString();
  } else if (typeof date === "string") {
    return new Date(date).toLocaleString();
  }

  return "";
};
